/**
 * Keeps the add-to-bag label showing what the shopper will actually pay.
 *
 * The button reads "Add to bag — $495.00". With a quantity selector on the page that
 * figure has to follow the quantity as well as the variant, otherwise it contradicts
 * the line it is about to create.
 *
 * The label is rebuilt rather than patched: product-info.js replaces it wholesale from
 * the re-rendered section on every variant change, so this listens for that event and
 * re-applies the quantity on top of the fresh price.
 */
(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const update = (scope) => {
    const button = scope.querySelector('.product-form__submit[data-unit-price]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const label = button.querySelector('span');
    const unit = parseInt(button.dataset.unitPrice, 10);
    if (!label || Number.isNaN(unit)) return;

    const input = scope.querySelector('.quantity__input');
    const qty = Math.max(1, parseInt(input?.value, 10) || 1);
    label.textContent = `${button.dataset.addLabel} — ${money(unit * qty, button.dataset.currency)}`;
  };

  const bind = (scope) => {
    const input = scope.querySelector('.quantity__input');
    if (!input || input.dataset.totalBound) return;
    input.dataset.totalBound = 'true';
    ['change', 'input'].forEach((event) => input.addEventListener(event, () => update(scope)));
  };

  document.querySelectorAll('.product__info-container').forEach((scope) => {
    bind(scope);
    update(scope);
  });

  // The quantity widget's own +/- buttons dispatch change on the input, but a variant
  // switch re-renders the whole block, so rebind and re-apply afterwards.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => {
        document.querySelectorAll('.product__info-container').forEach((scope) => {
          bind(scope);
          update(scope);
        });
      });
    });
  }
})();
